<template>
    <div class="content-page">
        <div class="tab-content">
          <el-form
            :model="enterpriseForm"
            ref="enterpriseForm"
            label-width="98px"
            class="shopsetting-form"
            width="328px"
            :hide-required-asterisk="true"
          >
            <el-form-item label="投放地址" prop="address">
              <el-input
                :disabled="true"
                v-model="enterpriseForm.address"
                placeholder="请填写投放地址"
                style="width: 400px;margin-right:20px;"
              ></el-input> 
              <el-button v-clipboard:copy="enterpriseForm.address" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
              <el-button @click="goManagePage">打开</el-button>
            </el-form-item>
          </el-form>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      enterpriseForm: {
        address: ""
      },
    }
  },
  mounted() {
    let url = window.location.href.substr(0, 28)
    this.enterpriseForm.address = url + 'manageData'
  },
  methods: {
    onCopy(e) {
      console.log(e.text)
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    onError(e) {

    },
    goManagePage() {
        let routeData = this.$router.resolve({
            path: "/manageData"
        });
        window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 20px;
  }
  .shopsetting-form {
    width: 100%;
  }
}
</style>